















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import AdminService from '@/api/AdminService';

import { Pagination, SortController } from '@/utils/Pagination';

import { HeaderList, List } from '@/components/Table/TableModel';
import Table from '@/components/molecules/Table/Table.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import UserIcon from '@/components/molecules/UserIcon/UserIcon.vue';
import { getWordInitials } from '@/utils/getWordInitials';

@Component({
  components: {
    Table,
    TableCell,
    TableHeader,
    TableRow,
    UserIcon
  }
})
export default class CustomerRecentActivity extends Vue {
  @Prop(String) customerId!: string;

  adminService: AdminService = new AdminService();
  pagination = new Pagination(this.formatRow);
  sort = new SortController();
  query: Record<string, any> = {};
  headers = [
    new HeaderList(`Business`, 'none', '12px 12px 12px 32px'),
    new HeaderList(`Business name`, 'business.name', '12px 32px 12px 12px')
  ];
  storesVisited: List = new List([], []);

  @Watch('query')
  refreshPagination(query: Record<string, any>) {
    this.pagination.refresh(
      `/super-admin/customer/${this.customerId}/visited-stores`,
      query
    );
  }

  formatRow(row: any) {
    return {
      ...row,
      logo:
        !row.logo || !row.logo.small
          ? getWordInitials(row.name)
          : row.logo.small
    };
  }

  handleUpdateSort(field: string) {
    this.sort.update(field);
    this.query = {
      ...this.query,
      sort: this.sort.toString()
    };
  }

  mounted() {
    this.query = Object.assign({}, this.query);
    this.pagination.setPaginationTarget(this.$refs.target as HTMLElement);
  }
}
